<template>
  <section>
    <article>
      <infinite-scroll>
        <class-list :user="user" :profile="profile"></class-list>
        <span class="loader" v-if="loading"></span>
      </infinite-scroll>
    </article>

  </section>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import imageProxy from '@/libs/image-proxy'
import componentState from '@/mixins/component-state'
import ClassList from '@/components/Pages/ManageClasses/ClassCardList'

export default {
  mixins: [componentState],
  components: {
    InfiniteScroll,
    ClassList
  },
  props: ['user', 'profile'],
  data: function () {
    return {
      limit: 16,
      offset: 0,
      total: 0,
      hasMore: true,
      loading: false,
      connections: [],
      createClassModal: false
    }
  },
  methods: {
    goToConnectedUser: function (username) {
      this.$router.push({ name: 'profile', params: { username } })
    },
    thumbnail: function (avatar) {
      return imageProxy.proxy(avatar, { width: 100, height: 100 })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
@media screen and (max-width: 425px) {
  justify-content: space-around;
}

li {
  width: 125px;
  text-align: center;
  margin: 1em;
@media screen and (max-width: 425px) {
  margin: 1em 0;
}

img {
  border: solid 3px #ffffff;
  height: 100px;
  width: 100px;
  max-width: 100%;
  transition: all 0.5s;
  -o-object-fit: cover;
  object-fit: cover;
&:hover {
   border: solid 3px $primary;
   cursor: pointer;
 }
@include hover-cards-effect
}

span {
  font-size: 0.9rem;
  color: #727272;
  line-height: 1.3rem;
  display: inline;
}
}
}
.bottom-space {
  padding-bottom: 15px;
}
.loader {
  display: block;
  font-size: 2rem;
  margin: 1rem auto;
}
</style>
